// Containers
import ContactSupport from "../containers/ContactSupport";
import CookiePolicy from "../containers/CookiePolicy";
import DemoVideosPage from "../containers/DemoVideosPage";
import Faqs from "../containers/Faqs";
import HomePage from "../containers/HomePage/HomePage";
import PressRelease from "../containers/PressRelease/index";
import PressReleaseSingle from "../containers/PressReleaseSingle/index";
import PromotionalMaterial from "../containers/PromotionalMaterial";
import RequestInclusion from "../containers/RequestInclusion";
import TermsAndConditions from "../containers/TermsAndConditions";
import VictimSupport from "../containers/VictimSupport";
import GetConnectedPage from "../containers/GetConnectedPage/GetConnectedPage";
import RequestReportPage from "../containers/RequestReportPage";
import SecurityPage from "../containers/SecurityPage";

import { urls } from "./urls";

// Routes
export const routes = [
  {
    component: DemoVideosPage,
    title: "kulpa Demo | See kulpa in action",
    id: "demoVideos",
    path: urls.demoVideos
  },
  {
    component: VictimSupport,
    title: "Victim Support",
    id: "victimSupport",
    path: urls.victimSupport
  },
  {
    component: ContactSupport,
    title: "Contact / Support",
    id: "contactSupport",
    path: urls.contactSupport
  },
  {
    component: GetConnectedPage,
    title: "Get Connected",
    id: "getConnected",
    path: urls.getConnected
  },
  {
    component: RequestReportPage,
    title: "Request Reports and BLUEPRINT",
    id: "requestReport",
    path: urls.requestReport
  },
  {
    component: PromotionalMaterial,
    title: "Promotional Material",
    id: "promotionalMaterial",
    path: urls.promotionalMaterial
  },
  {
    component: RequestInclusion,
    title: "Request Inclusion",
    id: "requestInclusion",
    path: urls.requestInclusion
  },
  {
    component: Faqs,
    title: "FAQs",
    id: "faqs",
    path: urls.faqs
  },
  {
    component: TermsAndConditions,
    title: "Terms And Conditions",
    id: "terms",
    path: urls.termsAndConditions,
    subs: {
      termsAndConditions: "#termsAndConditions",
      privacyPolicy: "#privacyPolicy"
    },
    isExact: false
  },
  {
    component: CookiePolicy,
    title: "Cookie Policy",
    id: "cookie",
    path: urls.cookie,
    isExact: false
  },
  {
    component: SecurityPage,
    title: "Security",
    id: "security",
    path: urls.security
  },
  {
    component: PressReleaseSingle,
    title: "Press Releases",
    id: "pressReleaseWithId",
    path: urls.pressReleasesWithId,
    isExact: true
  },
  {
    component: PressRelease,
    title: "Press Releases",
    id: "pressRelease",
    path: urls.pressReleases,
    isExact: true
  },
  {
    component: HomePage,
    title: "kulpa",
    id: "home",
    path: urls.home
  }
];

export const getRoutes = () => routes;
